import { render, staticRenderFns } from "./Teacher.vue?vue&type=template&id=28d31cd9&scoped=true&"
import script from "./Teacher.vue?vue&type=script&lang=js&"
export * from "./Teacher.vue?vue&type=script&lang=js&"
import style1 from "./Teacher.vue?vue&type=style&index=1&id=28d31cd9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d31cd9",
  null
  
)

export default component.exports